import {
    GendersEnum,
    UserStatusesEnum,
    PaymentMethodsEnum,
    ClientStatusesEnum,
    EnrollChannelsEnum,
    PaymentStatusesEnum,
    MiFidCategoriesEnum,
    ClientUserTypesEnum,
    OperatorStatusesEnum,
    DocumentStatusesEnum,
    PaymentProcessesEnum,
    PaymentProvidersEnum,
    FundOrderStatusesEnum,
    FundOrderTypesEnum,
    TradingCategoriesEnum,
    UserRelationTypesEnum,
    UserBehaviourTypesEnum,
    ClientStatusTriggersEnum,
    TradingGroupStatusesEnum,
    LinkedAccountTypesEnum,
    LinkedAccountStatusesEnum,
    DocumentStatusTriggersEnum,
    OperatorStatusTriggersEnum,
    TradingAccountStatusesEnum,
    RiskClassificationBandsEnum,
    ClientUserStatusesEnum,
    IdentityDocumentStatusesEnum,
    JurisdictionalCountryTypesEnum,
    AdjustmentCategoryEnum,
    CommonSearchFields,
    CurrencyTypesEnum,
    UserCategoryTypesEnum,
    SubscriptionHistroyEventTypesEnum,
    FeedUsageReportsGroupByTypesEnum,
    FundProductTypesEnum,
    FundProductStatusesEnum,
    FundProductPricesEnum,
    FundOrderPlacementMethodEnum,
    AccountSubTypeEnum,
    MessagingStatusesEnum,
    MessagingDistributionChannelsEnum,
    MessagingRequestTypesEnum,
    MessagingTemplateTypesEnum,
    CouponFrequency,
    ProductCategory,
    ProductGroup,
    ProductSubType,
    SettlementType,
    BarrierType,
    WarrantType,
    NasdaqReportMapsEnum,
    TradingPlanStatusEnum,
    TradingPlanTypeEnum,
    TradingPlanSubTypeEnum,
    FeeValidityEnum,
    TradingPlanPrizeTypeEnum,
    MifirTypesEnum,
    BrokerSearchExtendedType,
    ExecutionBrokerStatusEnum,
    AccountAutomaticActionType,
    AccountCloseoutAlgorithm,
    TradingPlanSuccessfulCompletionEnum, AccountPlanStatusEnum, PaymentPurchaseTypeEnum, CryptoWalletTypeEnum,
    CouponStatusEnum,
    CouponDiscountTypeEnum,
    CouponUserEligibilityTypeEnum,
    CouponPaymentMethodEnum,
    CouponApplicableToTypeEnum,
    CouponStatusTriggerEnum,
    PortalsEnum,
    CloseoutPlanTypeEnum,
    CloseoutPlanStatusEnum,
    CloseoutDeEscalationEnum,
    CloseoutPlanAccountOperationOutcomeEnum,
    AutomaticCloseoutStateEnum,
    AccountCreationChannelEnum,
    AccountCreationBatchOutcomeEnum,
} from '@spa/api';

import {CouponPlanScopeTypeEnum, PortalPermissionsEnum} from '../../../enums';

import {
    BankAccountTypesEnum,
    ClientTypesEnum,
    EnrollTypesEnum,
    FinancialInstitutionEnum,
    PepManagerApprovalEnum,
    ReportTypesEnum,
    TradingGroupClientTypesEnum,
    TradingGroupIsDefaultTypesEnum,
    TradingGroupLevelsEnum,
} from 'appEntries/panel/enums';

import {labels} from 'appAssets/tenants/labels';
import {EntitlementReportsProvidersEnum} from 'appEntries/panel/enums/entitlement-reports-providers.enum';
import {
    AddNewFeedProductCodeForNonProName,
    AddNewFeedProductCodeForProName,
    AddNewFeedReportTitleIdForNonProName,
    AddNewFeedReportTitleIdForProName
} from 'appAssets/selectors';

export class TextsHelper {
    private constructor() {
    }

    static boolTransformToYesNo(value: boolean) {
        return value ? 'Yes' : 'No';
    }

    static getAutomaticActionTypeName(automaticActionType?: number): string {
        switch (automaticActionType) {
            default:
                return '';
            case AccountAutomaticActionType.Liquidate:
                return 'Liquidate';
        }
    }

    static getAccountCloseoutAlgorithmName(closeoutAlgorithm?: number): string {
        switch (closeoutAlgorithm) {
            default:
                return 'N/A';
            case AccountCloseoutAlgorithm.NotAvailable:
                return 'Not available';
            case AccountCloseoutAlgorithm.LossBased:
                return 'Loss Based';
            case AccountCloseoutAlgorithm.UnrealizedLossPctOfCash:
                return 'Unrealized loss % of cash';
        }
    }

    /**
     * The per-account automatic closeout switch (BR-12): operators edit only Enabled/Suspended;
     * Observation is a backend rollout/shadow state shown read-only (C3).
     */
    static getAutomaticCloseoutStateName(state?: number): string {
        switch (state) {
            case AutomaticCloseoutStateEnum.Enabled:
                return 'Enabled';
            case AutomaticCloseoutStateEnum.Suspended:
                return 'Suspended';
            case AutomaticCloseoutStateEnum.Observation:
                return 'Observation';
        }
    }

    static getFeeValidityName(feeValidity?: number): string {
        switch (feeValidity) {
            default:
                return 'Missing';
            case FeeValidityEnum.Assigned:
                return 'Assigned';
            case FeeValidityEnum.AssignedAndValid:
                return 'Assigned and Valid';
            case FeeValidityEnum.AssignedAndExpired:
                return 'Assigned and Expired';
        }
    }

    static getDocumentStatusName(status: number): string {
        switch (status) {
            case DocumentStatusesEnum.All:
                return 'All';
            case DocumentStatusesEnum.New:
                return 'For approval';
            case DocumentStatusesEnum.InReview:
                return 'In review';
            case DocumentStatusesEnum.Approved:
                return 'Approved';
            case DocumentStatusesEnum.Archived:
                return 'Archived';
            case DocumentStatusesEnum.Expired:
                return 'Expired';
            case DocumentStatusesEnum.Declined:
                return 'Declined';
        }
    }

    static getDocumentStatusNameByTrigger(trigger: number): string {
        switch (trigger) {
            case DocumentStatusTriggersEnum.New:
                return 'For approval';
            case DocumentStatusTriggersEnum.InReview:
                return 'In review';
            case DocumentStatusTriggersEnum.Approved:
                return 'Approved';
            case DocumentStatusTriggersEnum.Archived:
                return 'Archived';
            case DocumentStatusTriggersEnum.Expired:
                return 'Expired';
            case DocumentStatusTriggersEnum.Declined:
                return 'Declined';
        }
    }

    static getDocumentNonExpirationDateText(hasExpiration: boolean): string {
        return !hasExpiration ? 'N/A' : 'Non-expiring';
    }

    static getIdentityDocumentStatusName(status: string): string {
        switch (status) {
            case IdentityDocumentStatusesEnum.Pending:
                return 'Pending';
            case IdentityDocumentStatusesEnum.WaitingForDocuments:
                return 'Waiting for documents';
            case IdentityDocumentStatusesEnum.Approved:
                return 'Approved';
            case IdentityDocumentStatusesEnum.Refused:
                return 'Refused';
        }
    }

    static getPaymentStatusName(status: number): string {
        switch (status) {
            case PaymentStatusesEnum.All:
                return 'All';
            case PaymentStatusesEnum.Approved:
                return 'Approved';
            case PaymentStatusesEnum.Canceled:
                return 'Cancelled by User';
            case PaymentStatusesEnum.CanceledByClient:
                return 'Cancelled by Client';
            case PaymentStatusesEnum.Completed:
                return 'Completed';
            case PaymentStatusesEnum.ForApproval:
                return 'For Approval';
            case PaymentStatusesEnum.New:
                return 'New';
            case PaymentStatusesEnum.OnHold:
                return 'On hold';
            case PaymentStatusesEnum.Pending:
                return 'Pending';
            case PaymentStatusesEnum.Processed:
                return 'Processed';
            case PaymentStatusesEnum.Rejected:
                return 'Rejected';
            case PaymentStatusesEnum.Deleted:
                return 'Deleted';
            case PaymentStatusesEnum.ApprovedByOperator:
                return 'Approved By Operator';
            case PaymentStatusesEnum.Processing:
                return 'Processing';
        }
    }

    static getPaymentProcessName(id: number): string {
        switch (id) {
            case PaymentProcessesEnum.All:
                return 'All';
            case PaymentProcessesEnum.Funding:
                return 'Deposit';
            case PaymentProcessesEnum.Withdrawal:
                return 'Withdrawal';
            case PaymentProcessesEnum.Transfer:
                return 'Transfer';
            case PaymentProcessesEnum.Adjustment:
                return 'Adjustment';
            case PaymentProcessesEnum.Purchase:
                return 'Charge';
            default:
                return '';
        }
    }

    static getPurchaseTypeName(id: number): string {
        switch (id) {
            case PaymentPurchaseTypeEnum.All:
                return 'All';
            case PaymentPurchaseTypeEnum.Plan:
                return 'Plan Purchase';
            case PaymentPurchaseTypeEnum.AccountExpiryExtension:
                return 'Plan Prolongation';
            case PaymentPurchaseTypeEnum.AccountDailyLossRewind:
                return 'DL Rewind';
            case PaymentPurchaseTypeEnum.AutoPass:
                return 'Disable AutoPass Purchase';
            case PaymentPurchaseTypeEnum.PlanWithAutoPass:
                return 'Plan Purchase with AutoPass';
            default:
                return '';
        }
    }

    static getPaymentMethodName(id: number): string {
        switch (id) {
            case PaymentMethodsEnum.All:
                return 'All';
            case PaymentMethodsEnum.BankTransfer:
                return 'Bank Transfer';
            case PaymentMethodsEnum.Cash:
                return 'Cash';
            case PaymentMethodsEnum.eWallet:
                return 'eWallet';
            case PaymentMethodsEnum.Card:
                return 'Card';
            case PaymentMethodsEnum.InternalTransfer:
                return 'Internal Transfer';
            case PaymentMethodsEnum.Adjustment:
                return 'Adjustment';
            case PaymentMethodsEnum.Crypto:
                return 'Crypto';
        }
    }

    static getPaymentProviderName(method: number, id: number): string {
        switch (method) {
            case PaymentMethodsEnum.BankTransfer:
                return 'Bank transfer';
            case PaymentMethodsEnum.Adjustment:
                return 'Adjustment';
            case PaymentMethodsEnum.Card:
                switch (id) {
                    case PaymentProvidersEnum.Stripe:
                        return 'Stripe';
                    case PaymentProvidersEnum.Revolut:
                        return 'Revolut';
                    default:
                        return '';
                }
            case PaymentMethodsEnum.eWallet:
                switch (id) {
                    case PaymentProvidersEnum.Skrill:
                        return 'Skrill';
                    case PaymentProvidersEnum.Neteller:
                        return 'Neteller';
                    default:
                        return '';
                }
            case PaymentMethodsEnum.Crypto:
                switch (id) {
                    case PaymentProvidersEnum.Bvnk:
                        return 'Bvnk';
                    default:
                        return '';
                }
            default:
                return '';
        }
    }

    static getOrderStatusName(status: number): string {
        switch (status) {
            case FundOrderStatusesEnum.All:
                return 'All';
            case FundOrderStatusesEnum.New:
                return 'New';
            case FundOrderStatusesEnum.Pending:
                return 'Pending';
            case FundOrderStatusesEnum.Matched:
                return 'Matched';
            case FundOrderStatusesEnum.Completed:
                return 'Completed';
            case FundOrderStatusesEnum.Rejected:
                return 'Rejected';
            case FundOrderStatusesEnum.Problematic:
                return 'Problematic';
            default:
                return '';
        }
    }

    static getOrderTypeName(type: number): string {
        switch (type) {
            case FundOrderTypesEnum.All:
                return 'All';
            case FundOrderTypesEnum.Buy:
                return 'Buy';
            case FundOrderTypesEnum.Sell:
                return 'Sell';
            case FundOrderTypesEnum.Payout:
                return 'Payout';
            default:
                return '';
        }
    }

    static getOrderPlacementMethod(type: number): string {
        switch (type) {
            case FundOrderPlacementMethodEnum.All:
                return 'All';
            case FundOrderPlacementMethodEnum.Electronic:
                return 'Electronic';
            case FundOrderPlacementMethodEnum.Manual:
                return 'Manual';
            default:
                return '';
        }
    }

    static getEnrollTypeName(key: string): string {
        switch (key) {
            case EnrollTypesEnum.All:
                return 'All';
            case EnrollTypesEnum.Individual:
                return 'Individual';
            case EnrollTypesEnum.Corporate:
                return 'Corporate';
        }
    }

    static getClientStatusName(status: number): string {
        switch (status) {
            case ClientStatusesEnum.New:
                return 'New';
            case ClientStatusesEnum.PendingDocuments:
                return 'Pending';
            case ClientStatusesEnum.PendingAcceptance:
                return 'Pending acceptance';
            case ClientStatusesEnum.InVerifications:
                return 'For verification';
            case ClientStatusesEnum.OnHold:
                return 'On hold';
            case ClientStatusesEnum.Verified:
                return 'Verified';
            case ClientStatusesEnum.Blocked:
                return 'Blocked';
            case ClientStatusesEnum.Active:
                return 'Active';
            case ClientStatusesEnum.Terminated:
                return 'Terminated';
            case ClientStatusesEnum.Declined:
                return 'Declined';
            default:
                return 'All';
        }
    }

    static getClientStatusNameByTrigger(trigger: number): string {
        switch (trigger) {
            case ClientStatusTriggersEnum.New:
                return 'New';
            case ClientStatusTriggersEnum.PendingDocuments:
                return 'Pending';
            case ClientStatusTriggersEnum.PendingAcceptance:
                return 'Pending acceptance';
            case ClientStatusTriggersEnum.ForVerification:
                return 'For verification';
            case ClientStatusTriggersEnum.PutOnHold:
                return 'On hold';
            case ClientStatusTriggersEnum.Verify:
                return 'Verified';
            case ClientStatusTriggersEnum.Block:
                return 'Blocked';
            case ClientStatusTriggersEnum.Activate:
                return 'Active';
            case ClientStatusTriggersEnum.Terminate:
                return 'Terminated';
            case ClientStatusTriggersEnum.Decline:
                return 'Declined';
        }
    }

    static getEnrollChannelName(id: string): string {
        switch (id) {
            case EnrollChannelsEnum.Offline:
                return 'Offline';
            case EnrollChannelsEnum.Web:
                return 'Web';
            case EnrollChannelsEnum.Mobile:
                return 'Mobile';
            default:
                return '';
        }
    }

    static getUserTypeBehaviourName(type: number): string {
        switch (type) {
            case UserBehaviourTypesEnum.All:
                return 'All';
            case UserBehaviourTypesEnum.CRM:
                return labels.tenant + ' CRM';
            case UserBehaviourTypesEnum.Pro:
                return labels.tenant + ' ' + labels.tenantProPortal;
            case UserBehaviourTypesEnum.Retail:
                return labels.tenant + ' ' + labels.tenantRetailPortal;
            default:
                return '';
        }
    }

    static getGenderName(gender: string): string {
        switch (gender) {
            case GendersEnum.Male:
                return 'Male';
            case GendersEnum.Female:
                return 'Female';
            default:
                return '';
        }
    }

    static getRiskClassificationBandName(id: number): string {
        switch (id) {
            case RiskClassificationBandsEnum.All:
                return 'All';
            case RiskClassificationBandsEnum.Blacklisted:
                return 'Blacklisted';
            case RiskClassificationBandsEnum.High:
                return 'High';
            case RiskClassificationBandsEnum.Medium:
                return 'Medium';
            case RiskClassificationBandsEnum.Low:
                return 'Low';
            default:
                return 'N/A';
        }
    }

    static getJurisdictionalRiskItemTypeName(type: string): string {
        switch (type) {
            case JurisdictionalCountryTypesEnum.Nationality:
                return 'Nationality';
            case JurisdictionalCountryTypesEnum.Residence:
                return 'Residential';
            case JurisdictionalCountryTypesEnum.InitialDeposit:
                return 'Initial Deposit';
        }
    }

    static getPepManagerApprovalName(approval: number): string {
        switch (approval) {
            case PepManagerApprovalEnum.All:
                return 'All';
            case PepManagerApprovalEnum.None:
                return 'N/A';
            case PepManagerApprovalEnum.Yes:
                return 'Yes';
            case PepManagerApprovalEnum.No:
                return 'No';
        }
    }

    static getClientUserTypeName(type: number): string {
        switch (type) {
            case ClientUserTypesEnum.All:
                return 'All';
            case ClientUserTypesEnum.LegalRepresentative:
                return 'Legal Representative';
            case ClientUserTypesEnum.AuthorizedPerson:
                return 'Authorized Person';
            default:
                return '';
        }
    }

    static getUserStatusName(status: number): string {
        switch (status) {
            case UserStatusesEnum.New:
                return 'New';
            case UserStatusesEnum.Active:
                return 'Active';
            case UserStatusesEnum.Closed:
                return 'Closed';
            case UserStatusesEnum.Terminated:
                return 'Terminated';
            default:
                return '';
        }
    }

    static getClientUserStatusName(status: number): string {
        switch (status) {
            case ClientUserStatusesEnum.All:
                return 'All';
            case ClientUserStatusesEnum.ForConfirmation:
                return 'For Confirmation';
            case ClientUserStatusesEnum.ForVerification:
                return 'For Verification';
            case ClientUserStatusesEnum.Rejected:
                return 'Rejected';
            case ClientUserStatusesEnum.Verified:
                return 'Verified';
            case ClientUserStatusesEnum.Declined:
                return 'Declined';
            case ClientUserStatusesEnum.Active:
                return 'Active';
            case ClientUserStatusesEnum.ForDeactivation:
                return 'For Deactivation';
            case ClientUserStatusesEnum.Deactivated:
                return 'Deactivated';
            case ClientUserStatusesEnum.Blocked:
                return 'Blocked';
            default:
                return '';
        }
    }

    static getMarketDataHistoryEventName(status: string): string {
        switch (status) {
            case SubscriptionHistroyEventTypesEnum.willBeDeactivated:
                return 'Forthcoming deactivation';
            case SubscriptionHistroyEventTypesEnum.willBeActivated:
                return 'Upcoming activation';
            case SubscriptionHistroyEventTypesEnum.Cancelled:
                return 'Cancelled';
            case SubscriptionHistroyEventTypesEnum.Activated:
                return 'Activated';
            case SubscriptionHistroyEventTypesEnum.Deactivated:
                return 'Deactivated';
            default:
                return '';
        }
    }

    static getUserTwoFactorEnabledText(isEnabled: boolean): string {
        return !isEnabled ? 'Off' : 'On';
    }

    static getClientTypeName(type: number): string {
        switch (type) {
            case ClientTypesEnum.Individual:
                return 'Individual';
            case ClientTypesEnum.Corporate:
                return 'Corporate';
            default:
                return '';
        }
    }

    static getClientTypeByClientUserRelationType(type: number): string {
        switch (type) {
            case UserRelationTypesEnum.IndividualSubordinate:
                return 'Individual';
            case UserRelationTypesEnum.CompanyEmployee:
                return 'Corporate';
            default:
                return '';
        }
    }

    static getUserRelationType(type: number): string {
        switch (type) {
            case UserRelationTypesEnum.Individual:
                return 'Individual';
            case UserRelationTypesEnum.CompanyEmployee:
                return 'Corporate';
            case UserRelationTypesEnum.Operator:
                return 'Operator';
            default:
                return '';
        }
    }

    static getMiFidCategoryName(category: number): string {
        switch (category) {
            case MiFidCategoriesEnum.Retail:
                return 'Retail';
            case MiFidCategoriesEnum.Professional:
                return 'Professional';
            case MiFidCategoriesEnum.Eligible:
                return 'Eligible Counterparty';
            default:
                return '';
        }
    }

    static getMiFirTypeName(type: number): string {
        switch (type) {
            case MifirTypesEnum.NIDN:
                return 'NIDN';
            case MifirTypesEnum.CCPT:
                return 'CCPT';
            case MifirTypesEnum.CONCAT:
                return 'CONCAT';
            default:
                return '';
        }
    }

    static getFinancialInstitutionOptionName(option: number): string {
        switch (option) {
            case FinancialInstitutionEnum.No:
                return 'No';
            case FinancialInstitutionEnum.Yes:
                return 'Yes';
            default:
                return '';
        }
    }

    static getTradingAccountTypeName(isCash: boolean = null): string {
        if (isCash !== null) {
            return !isCash ? 'Trading' : 'Cash';
        }

        return 'All';
    }

    static getAccountSubTypeName(type: AccountSubTypeEnum): string {
        switch (type) {
            case AccountSubTypeEnum.TradingCash:
                return 'Trading Cash';
            case AccountSubTypeEnum.FundCash:
                return 'Fund Cash';
            case AccountSubTypeEnum.MutualFund:
                return 'Mutual Fund';
            case AccountSubTypeEnum.Trading:
                return 'Trading';
            case AccountSubTypeEnum.InstrumentCertificate:
                return 'Investment Certificate';
            default:
                return '';
        }
    }

    static getCashAccountStatusName(status: number): string {
        switch (status) {
            case TradingAccountStatusesEnum.Unspecified:
                return 'All';
            case TradingAccountStatusesEnum.ForApproval:
                return 'For Approval';
            case TradingAccountStatusesEnum.PendingActivation:
                return 'Pending Activation';
            case TradingAccountStatusesEnum.Rejected:
                return 'Rejected';
            case TradingAccountStatusesEnum.Active:
                return 'Active';
            case TradingAccountStatusesEnum.WithdrawalRestricted:
                return 'Withdrawal Restricted';
            case TradingAccountStatusesEnum.Blocked:
                return 'Blocked';
            case TradingAccountStatusesEnum.Closed:
                return 'Closed';
        }
    }

    static getTradingAccountStatusName(status: number): string {
        switch (status) {
            case TradingAccountStatusesEnum.Unspecified:
                return 'All';
            case TradingAccountStatusesEnum.ForApproval:
                return 'For Approval';
            case TradingAccountStatusesEnum.PendingActivation:
                return 'Pending Activation';
            case TradingAccountStatusesEnum.Rejected:
                return 'Rejected';
            case TradingAccountStatusesEnum.Active:
                return 'Active';
            case TradingAccountStatusesEnum.WithdrawalRestricted:
                return 'Withdrawal Restricted';
            case TradingAccountStatusesEnum.Blocked:
                return 'Blocked';
            case TradingAccountStatusesEnum.BlockOrderEntry:
                return 'Block Order Entry';
            case TradingAccountStatusesEnum.BlockShortSells:
                return 'Block Short Sells';
            case TradingAccountStatusesEnum.Closed:
                return 'Closed';
            case TradingAccountStatusesEnum.ClosedCancel:
                return 'Closed Cancel';
            case TradingAccountStatusesEnum.AwaitingFunding:
                return 'Awaiting Funding';
        }
    }

    static getTradingGroupStatusV2Name(status: number): string {
        switch (status) {
            case TradingGroupStatusesEnum.Unspecified:
                return 'All';
            case TradingGroupStatusesEnum.Active:
                return 'Active';
            case TradingGroupStatusesEnum.Inactive:
                return 'Inactive';
            case TradingGroupStatusesEnum.Closed:
                return 'Closed';
        }
    }

    static getEntitlementReportsProvidersName(status: number): string {
        switch (status) {
            case EntitlementReportsProvidersEnum.NASDAQ:
                return 'Nasdaq';
            case EntitlementReportsProvidersEnum.NASDAQUTP:
                return 'Nasdaq Utp';
            case EntitlementReportsProvidersEnum.NYSE:
                return 'Nyse';
            case EntitlementReportsProvidersEnum.CBOE:
                return 'Cboe';
            default:
                return '';
        }
    }

    static getMarketDataUsageReportsGroupingName(status: FeedUsageReportsGroupByTypesEnum): string {
        switch (status) {
            case FeedUsageReportsGroupByTypesEnum.USER_ID:
                return 'User';
            case FeedUsageReportsGroupByTypesEnum.ACCOUNT_ID:
                return 'Account';
            case FeedUsageReportsGroupByTypesEnum.BUNDLE_NAME:
                return 'Feed/Bundle';
            case FeedUsageReportsGroupByTypesEnum.MONTH:
                return 'Month';
            default:
                return '';
        }
    }

    static getIsInvestmentFirm(category: number): string {
        switch (category) {
            case TradingCategoriesEnum.Retail:
                return 'No';
            case TradingCategoriesEnum.Group:
                return 'Yes';
            default:
                return '';
        }
    }

    static getClientUserUsageCategoryTypes(category: string): string {
        switch (category) {
            case UserCategoryTypesEnum.Service:
                return 'Service';
            case UserCategoryTypesEnum.Pro:
                return 'Pro';
            case UserCategoryTypesEnum.NonPro:
                return 'Non Pro';
            default:
                return '';
        }
    }

    static getNasdaqReportMapText(reportMap: NasdaqReportMapsEnum): string {
        if (reportMap === NasdaqReportMapsEnum.ProductCodeForPro) {
            return AddNewFeedProductCodeForProName;
        }

        if (reportMap === NasdaqReportMapsEnum.ProductCodeForNonPro) {
            return AddNewFeedProductCodeForNonProName;
        }

        if (reportMap === NasdaqReportMapsEnum.ReportTitleIdForPro) {
            return AddNewFeedReportTitleIdForProName;
        }

        if (reportMap === NasdaqReportMapsEnum.ReportTitleIdForNonPro) {
            return AddNewFeedReportTitleIdForNonProName;
        }

        return '';
    }

    static getTradingGroupClientType(type: number): string {
        switch (type) {
            case TradingGroupClientTypesEnum.All:
                return 'All';
            case TradingGroupClientTypesEnum.Individual:
                return 'Individual';
            case TradingGroupClientTypesEnum.Company:
                return 'Company';
        }
    }

    static getTradingGroupsIsDefaultText(type: number): string {
        switch (type) {
            case TradingGroupIsDefaultTypesEnum.All:
                return 'All';
            case TradingGroupIsDefaultTypesEnum.Yes:
                return 'Yes';
            case TradingGroupIsDefaultTypesEnum.No:
                return 'No';
        }
    }

    static getTradingGroupLevelName(level: number): string {
        switch (level) {
            case TradingGroupLevelsEnum.All:
                return 'All';
            case TradingGroupLevelsEnum.Firm:
                return 'Client';
            case TradingGroupLevelsEnum.Tenant:
                return 'Tenant';
        }
    }

    static getPortalManagerialRightsPermissionName(permissionString: string): string {
        switch (permissionString) {
            case PortalPermissionsEnum.AddBankAccount:
                return 'Add New Bank Account';
            case PortalPermissionsEnum.ViewBankAccount:
                return 'View Bank Account';
            case PortalPermissionsEnum.EditBankAccount:
                return 'Edit Bank Account';
            case PortalPermissionsEnum.CashAccountsCreateNew:
                return 'Create New Cash Account';
            case PortalPermissionsEnum.CashAccountsDelete:
                return 'Delete Cash Account';
        }
    }

    static getPortalCashOperationsPermissionName(permissionString: string): string {
        switch (permissionString) {
            case PortalPermissionsEnum.CreateNewWithdrawals:
                return 'Create New Withdrawal';
            case PortalPermissionsEnum.CreateNewDeposits:
                return 'Create New Deposit';
            case PortalPermissionsEnum.NewInternalTransfer:
                return 'Create New Internal Transfer';
            case PortalPermissionsEnum.UpdatePaymentDetails:
                return 'Update Payment Details';
            case PortalPermissionsEnum.CashOperationsViewTransactionHistoryAndPendingWithdrawals:
                return 'View Cash Operations';
        }
    }

    static getPortalReportsPermissionName(permissionString: string): string {
        switch (permissionString) {
            case PortalPermissionsEnum.ViewTradingAccountStatementsAndReports:
                return 'View Accounts Reports';
            case PortalPermissionsEnum.ViewGroupStatementsAndReports:
                return 'View Groups Reports';
        }
    }

    static getPortalMdsPermissionName(permissionString: string): string {
        switch (permissionString) {
            case PortalPermissionsEnum.SubscriptionManagementViewAssignedFeeds:
                return 'View Assigned Feeds';
            case PortalPermissionsEnum.SubscriptionManagementViewRevenue:
                return 'View Revenue';
            case PortalPermissionsEnum.SubscriptionManagementViewSubscriptionPrice:
                return 'View Subscription Price';
            case PortalPermissionsEnum.SubscriptionManagementAssignFeedsToUsers:
                return 'Assign Feeds To User';
            case PortalPermissionsEnum.SubscriptionManagementEditAssignedFeeds:
                return 'Edit Assigned Feeds';
            case PortalPermissionsEnum.SubscriptionManagementViewFeedPrice:
                return 'View Feed Price';
            case PortalPermissionsEnum.SubscriptionManagementViewMarkups:
                return 'View Markup';
            case PortalPermissionsEnum.SubscriptionManagementSetMarkups:
                return 'Set Markup';
            case PortalPermissionsEnum.SubscriptionManagementViewEventHistory:
                return 'View Event History';
            case PortalPermissionsEnum.SubscriptionManagementViewMarketDataUsageReports:
                return 'View Usage Reports';
            case PortalPermissionsEnum.SubscriptionManagementViewAvailableFeeds:
                return 'View Available Feeds';
        }
    }

    static getPortalUsersPermissionName(permissionString: string): string {
        switch (permissionString) {
            case PortalPermissionsEnum.AddNewClientUser:
                return 'Create New Client User';
            case PortalPermissionsEnum.ViewClientUserDetails:
                return 'View Client User';
            case PortalPermissionsEnum.EditClientUserDetails:
                return 'Edit Client User';
            case PortalPermissionsEnum.DeleteClientUser:
                return 'Delete Client User';
        }
    }

    static getPortalTradingAccountPermissionName(permissionString: string): string {
        switch (permissionString) {
            case PortalPermissionsEnum.TradingAccountsView:
                return 'View Account';
            case PortalPermissionsEnum.TradingAccountsEdit:
                return 'Edit Account';
            case PortalPermissionsEnum.TradingAccountsViewReports:
                return 'View Reports';
            case PortalPermissionsEnum.TradingAccountsExecuteTrades:
                return 'Execute Trades';
            case PortalPermissionsEnum.TradingAccountsCreateNewDeposits:
                return 'Create Deposit';
            case PortalPermissionsEnum.TradingAccountsCreateNewWithdrawals:
                return 'Create Withdrawals';
            case PortalPermissionsEnum.TradingAccountsCreateNewTransfers:
                return 'Create Internal Transfer';
            case PortalPermissionsEnum.TradingAccountsExchangeCurrency:
                return 'Exchange Currency';
            case PortalPermissionsEnum.FPManageAccounts:
                return 'FP Manage Accounts';
        }
    }

    static getPortalCashAccountPermissionName(permissionString: string): string {
        switch (permissionString) {
            case PortalPermissionsEnum.CashAccountsView:
                return 'View Account';
            case PortalPermissionsEnum.CashAccountsEdit:
                return 'Edit Account';
            case PortalPermissionsEnum.CashAccountsViewReports:
                return 'View Reports';
            case PortalPermissionsEnum.TradingAccountsCreateNew:
                return 'Create Sub Account';
            case PortalPermissionsEnum.TradingAccountsDelete:
                return 'Delete Sub Account';
            case PortalPermissionsEnum.CashAccountsCreateNewDeposits:
                return 'Create Deposit';
            case PortalPermissionsEnum.CashAccountsCreateNewWithdrawals:
                return 'Create Withdrawal';
            case PortalPermissionsEnum.CashAccountsCreateNewTransfers:
                return 'Create Internal Transfer';
            case PortalPermissionsEnum.FPManageAccounts:
                return 'FP Manage Accounts';
        }
    }

    static getPortalSupervisedPermissionName(permissionString: string): string {
        switch (permissionString) {
            case PortalPermissionsEnum.ViewSupervisedUserDetails:
                return 'View User Details';
            case PortalPermissionsEnum.EditSupervisedUserDetails:
                return 'Edit User Details';
            case PortalPermissionsEnum.DeleteSupervisedUser:
                return 'Delete User';
        }
    }

    static getPortalCurrencyExchangePermissionName(permissionString: string): string {
        switch (permissionString) {
            case PortalPermissionsEnum.CurrencyExchangeExchangeCurrency:
                return 'Exchange Currency';
            case PortalPermissionsEnum.CurrencyExchangeViewCurrencyTransactions:
                return 'View Currency Transactions';
        }
    }

    static getPortalFundPortalPermissionName(permissionString: string): string {
        switch (permissionString) {
            case PortalPermissionsEnum.FPManageAccounts:
                return 'Manage Accounts';
            case PortalPermissionsEnum.FPDocumentsView:
                return 'View Documents';
            case PortalPermissionsEnum.FPDocumentsUploadNew:
                return 'Upload New Documents';
            case PortalPermissionsEnum.FPDocumentsUpdate:
                return 'Update Documents';
            case PortalPermissionsEnum.FPDocumentsDownloadPreview:
                return 'Download Documents';
            case PortalPermissionsEnum.FPDocumentsDelete:
                return 'Delete Documents';
        }
    }

    static getBankAccountTypeName(type: number, useApiTypes = false): string {
        if (useApiTypes) {
            switch (type) {
                case LinkedAccountTypesEnum.All:
                    return 'All';
                case LinkedAccountTypesEnum.Iban:
                    return 'IBAN';
                case LinkedAccountTypesEnum.Account:
                    return 'Bank Account';
                case LinkedAccountTypesEnum.SortCode:
                    return 'Sort Code';
                case LinkedAccountTypesEnum.CryptoWallet:
                    return 'Crypto Wallet';
            }
        }

        switch (type) {
            case BankAccountTypesEnum.Iban:
                return 'IBAN';
            case BankAccountTypesEnum.BankAccount:
                return 'Bank Account';
            case BankAccountTypesEnum.SortCode:
                return 'Sort Code';
            case BankAccountTypesEnum.CryptoWallet:
                return 'Crypto Wallet';
        }
    }

    static getBankAccountStatusName(status: number): string {
        switch (status) {
            case LinkedAccountStatusesEnum.All:
                return 'All';
            case LinkedAccountStatusesEnum.New:
                return 'New';
            case LinkedAccountStatusesEnum.Active:
                return 'Active';
            case LinkedAccountStatusesEnum.Inactive:
                return 'Inactive';

        }
    }

    static getCryptoWalletTypeName(type: number): string {
        switch (type) {
            case CryptoWalletTypeEnum.Custodial:
                return 'Custodial';
            case CryptoWalletTypeEnum.NonCustodial:
                return 'Non-Custodial';
            case CryptoWalletTypeEnum.WatchOnly:
                return 'Watch-Only';

        }
    }

    static getOperatorStatusName(status: number): string {
        switch (status) {
            case OperatorStatusesEnum.PendingConfirmation:
                return 'Pending Confirmation';
            case OperatorStatusesEnum.Active:
                return 'Active';
            case OperatorStatusesEnum.Inactive:
                return 'Inactive';
            case OperatorStatusesEnum.Deleted:
                return 'Deleted';
        }
    }

    static getCurrencyTypesName(currency: string): string {
        switch (currency) {
            case CurrencyTypesEnum.Usd:
                return 'USD';
            case CurrencyTypesEnum.Euro:
                return 'EUR';
        }
    }

    static getOperatorStatusNameByTrigger(trigger: number): string {
        switch (trigger) {
            case OperatorStatusTriggersEnum.PendingConfirmation:
                return 'Pending Confirmation';
            case OperatorStatusTriggersEnum.Activate:
                return 'Active';
            case OperatorStatusTriggersEnum.Inactivate:
                return 'Inactive';
            case OperatorStatusTriggersEnum.Delete:
                return 'Deleted';
        }
    }

    static getAccountReportName(type: number): string {
        switch (type) {
            case ReportTypesEnum.Trades:
                return 'Trades';
            case ReportTypesEnum.Adjustments:
                return 'Adjustments';
            case ReportTypesEnum.OpenPositions:
                return 'Open Positions';
            case ReportTypesEnum.Detailed:
                return 'Detailed';
            case ReportTypesEnum.TotalsBySymbol:
                return 'Totals By Symbol';
            case ReportTypesEnum.TotalsByDate:
                return 'Totals By Date';
            case ReportTypesEnum.SummaryByDate:
                return 'Summary By Date';
            case ReportTypesEnum.FeesByDestination:
                return 'Fees By Destination';
        }
    }

    static getGroupReportName(type: number): string {
        switch (type) {
            case ReportTypesEnum.GroupSummaryByDate:
                return 'Group Summary By Date';
            case ReportTypesEnum.TotalsByGroup:
                return 'Totals By Groups';
            case ReportTypesEnum.GroupTotalsBySymbol:
                return 'Group Totals By Symbol';
            case ReportTypesEnum.GroupFeesByDestination:
                return 'Group Fees By Destination';
            case ReportTypesEnum.GroupOpenPositions:
                return 'Group Open Positions';
            case ReportTypesEnum.GroupAdjustments:
                return 'Group Adjustments';
            case ReportTypesEnum.TotalsByAccount:
                return 'Totals By Accounts';
        }
    }

    static getMessageRequestTypeName(type: string): string {
        if (type === MessagingRequestTypesEnum.Manual) {
            return 'Empty Message Form';
        }

        if (type === MessagingRequestTypesEnum.Template) {
            return 'From Template';
        }

        return '';
    }

    static getMessageTemplateTypeName(type: string): string {
        if (type === MessagingTemplateTypesEnum.New) {
            return 'New Message Template';
        }

        if (type === MessagingTemplateTypesEnum.Additional) {
            return 'New Additional Level Message Template';
        }

        return '';
    }

    static getMessagingImportanceLevel(importanceLevel: number): string {
        return importanceLevel > 0 ? 'Yes' : 'No';
    }

    static getAdjustmentCategoryName(type: string): string {
        switch (type) {
            case AdjustmentCategoryEnum.StockLocate:
                return 'Stock Locate';
            case AdjustmentCategoryEnum.Software:
                return 'Software';
            case AdjustmentCategoryEnum.ShortMarginInterest:
                return 'Short Margin Interest';
            case AdjustmentCategoryEnum.Platform:
                return 'Platform';
            case AdjustmentCategoryEnum.PNL:
                return 'PNL';
            case AdjustmentCategoryEnum.OvernightBorrow:
                return 'Overnight Borrow';
            case AdjustmentCategoryEnum.Miscellaneous:
                return 'Miscellaneous';
            case AdjustmentCategoryEnum.MarketData:
                return 'Market Data';
            case AdjustmentCategoryEnum.Invoice:
                return 'Invoice';
            case AdjustmentCategoryEnum.Dividend:
                return 'Dividend';
            case AdjustmentCategoryEnum.eSignal:
                return 'eSignal';
            case AdjustmentCategoryEnum.Bundle:
                return 'Bundle';
            case AdjustmentCategoryEnum.Rebate:
                return 'Rebate';
            case AdjustmentCategoryEnum.DailyInterest:
                return 'Daily Interest';
            case AdjustmentCategoryEnum.DailyFreeCashInterest:
                return 'Daily Free Cash Interest';
        }
    }

    static getCommonSearchFieldName(field: CommonSearchFields): string {
        switch (field) {
            case CommonSearchFields.All:
                return 'All';
            case CommonSearchFields.Name:
                return 'Name';
            case CommonSearchFields.Email:
                return 'Email';
            case CommonSearchFields.Account:
                return 'Account';
            default:
                return '';
        }
    }

    static getExtendedClientId(id: number, isCorporate: boolean): string {
        const extendedId = this.prependWithCharacter(id.toString(), '0', 6);

        if (isCorporate) {
            return `C${extendedId}`;
        }

        return `I${extendedId}`;
    }

    static getExtendedClientUserId(id: number, isCorporate: boolean): string {
        const extendedId = this.prependWithCharacter(id.toString(), '0', 6);

        if (isCorporate) {
            return `E${extendedId}`;
        }

        return `U${extendedId}`;
    }

    static prependWithCharacter(input: string, character: string, maxLength: number): string {
        if (!input) {
            return '';
        }

        return input.toString().padStart(maxLength, character);
    }

    static getProductTypeName(type: number): string {
        switch (type) {
            case FundProductTypesEnum.All:
                return 'All';
            case FundProductTypesEnum.InvestmentCertificate:
                return 'Investment Certificate';
            case FundProductTypesEnum.MutualFund:
                return 'Mutual Fund';
            case FundProductTypesEnum.Bonds:
                return 'Bonds';
            default:
                return '';
        }
    }

    static getProductStatusName(status: number): string {
        switch (status) {
            case FundProductStatusesEnum.Inactive:
                return 'Inactive';
            case FundProductStatusesEnum.Active:
                return 'Active';
            case FundProductStatusesEnum.Expired:
                return 'Expired';
            case FundProductStatusesEnum.InSubscription:
                return 'In Subscription';
            default:
                return '';
        }
    }

    static getProductPriceTypeName(type: number): string {
        switch (type) {
            case FundProductPricesEnum.IssuePrice:
                return 'Issue Price';
            case FundProductPricesEnum.BidPrice:
                return 'Bid Price';
            case FundProductPricesEnum.PenalRedemptionPrice:
                return 'Penal Redemption Price';
            case FundProductPricesEnum.NetAssetValue:
                return 'Net Asset Value';
            case FundProductPricesEnum.AskPrice:
                return 'Ask Price';
            default:
                return '';
        }
    }

    static getInterestPaymentPeriodName(frequency: number): string {
        switch (frequency) {
            case CouponFrequency.All:
                return 'All';
            case CouponFrequency.Monthly:
                return 'Monthly';
            case CouponFrequency.Quarterly:
                return 'Quarterly';
            case CouponFrequency.SemiAnually:
                return 'Semi Anually';
            case CouponFrequency.Anually:
                return 'Anually';
            default:
                return '';
        }
    }

    static getProductCategoryName(category: number): string {
        switch (category) {
            case ProductCategory.NotAvailable:
                return 'N/A';
            case ProductCategory.CapitalProtection:
                return 'Capital Protection';
            case ProductCategory.InvestmentProductswithadditionalcreditrisk:
                return 'Investment Products with Additional Credit Risk';
            case ProductCategory.Leverage:
                return 'Leverage';
            case ProductCategory.Participation:
                return 'Participation';
            case ProductCategory.YieldEnhancement:
                return 'Yield Enhancement';
            case ProductCategory.FixedRateBonds:
                return 'Fixed Rate Coupon Bonds';
            case ProductCategory.FloatingRateBonds:
                return 'Floating Rate Coupon Bonds';
            case ProductCategory.ZeroCouponBonds:
                return 'Zero Coupon Bonds';
            default:
                return '';
        }
    }

    static getProductSubTypeName(type: number): string {
        switch (type) {
            case ProductCategory.NotAvailable:
                return 'N/A';
            case ProductSubType.BarrierDiscountCertificate:
                return 'Barrier Discount Certificate';
            case ProductSubType.MultiBarrierDiscountCertificate:
                return 'Multi Barrier Discount Certificate';
            case ProductSubType.AutocallableMultiBarrierReverseConvertible:
                return 'Autocallable Multi Barrier Reverse Convertible';
            case ProductSubType.BarrierReverseConvertible:
                return 'Barrier Reverse Convertible';
            case ProductSubType.CallableMultiBarrierReverseConvertible:
                return 'Callable Multi Barrier Reverse Convertible';
            case ProductSubType.CallableBarrierReverseConvertible:
                return 'Callable Barrier Reverse Convertible';
            case ProductSubType.LockInCertificate:
                return 'Lock-In Certificate';
            case ProductSubType.MultiBarrierReverseConvertible:
                return 'Multi Barrier Reverse Convertible';
            case ProductSubType.ConditionalCouponBarrierReverseConvertible:
                return 'Conditional Coupon Barrier Reverse Convertible';
            case ProductSubType.ConditionalCouponMultiBarrierReverseConvertible:
                return 'Conditional Coupon Multi Barrier Reverse Convertible';
            case ProductSubType.ConditionalCouponMultiReverseConvertible:
                return 'Conditional Coupon Multi Reverse Convertible';
            case ProductSubType.DiscountCertificate:
                return 'Discount Certificate';
            case ProductSubType.MultiExpressCertificatewithBarrier:
                return 'Multi Express Certificate with Barrier';
            case ProductSubType.MiscellaneousYieldEnhancementCertificates:
                return 'Miscellaneous Yield Enhancement Certificates';
            case ProductSubType.AutocallableMultiReverseConvertible:
                return 'Autocallable Multi Reverse Convertible';
            case ProductSubType.AutocallableReverseConvertible:
                return 'Autocallable Reverse Convertible';
            case ProductSubType.CallableMultiReverseConvertible:
                return 'Callable Multi Reverse Convertible';
            case ProductSubType.CallableReverseConvertible:
                return 'Callable Reverse Convertible';
            case ProductSubType.MultiReverseConvertible:
                return 'Multi Reverse Convertible';
            case ProductSubType.ReverseConvertible:
                return 'Reverse Convertible';
            case ProductSubType.BonusCertificate:
                return 'Bonus Certificate';
            case ProductSubType.CappedBonusCertificate:
                return 'Capped Bonus Certificate';
            case ProductSubType.CappedMultiBonusCertificate:
                return 'Capped Multi Bonus Certificate';
            case ProductSubType.CouponMultiBonusCertificate:
                return 'Coupon Multi Bonus Certificate';
            case ProductSubType.MultiBonusCertificate:
                return 'Multi Bonus Certificate';
            case ProductSubType.MultiBonusOutperformanceCertificate:
                return 'Multi Bonus Outperformance Certificate';
            case ProductSubType.MiscellaneousParticipationCertificate:
                return 'Miscellaneous Participation Certificate';
            case ProductSubType.CappedOutperformanceCertificate:
                return 'Capped Outperformance Certificate';
            case ProductSubType.OutperformanceCertificate:
                return 'Outperformance Certificate';
            case ProductSubType.ActivelyManagedCertificate:
                return 'Actively Managed Certificate';
            case ProductSubType.TrackerCertificate:
                return 'Tracker Certificate';
            case ProductSubType.MiniFuture:
                return 'Mini Future';
            case ProductSubType.Warrant:
                return 'Warrant';
            case ProductSubType.ReferenceEntityCertificatewithConditionalCapitalProtection:
                return 'Reference Entity Certificate with Conditional Capital Protection';
            case ProductSubType.CapitalProtectionCertificatewithBarrier:
                return 'Capital Protection Certificate with Barrier';
            case ProductSubType.AutocallablesCapitalProtectionCertificatewithCoupon:
                return 'Autocallables Capital Protection Certificate with Coupon';
            case ProductSubType.CapitalProtectionCertificatewithCoupon:
                return 'Capital Protection Certificate with Coupon';
            case ProductSubType.CapitalProtectedCertificatewithCap:
                return 'Capital Protected Certificate with Cap';
            case ProductSubType.CapitalProtectedCertificatewithoutCap:
                return 'Capital Protected Certificate without Cap';
            case ProductSubType.MiscellaneousCapitalProtectedCertificates:
                return 'Miscellaneous Capital Protected Certificates';
            case ProductSubType.GovernmentBonds:
                return 'Government Bonds';
            case ProductSubType.MunicipalBonds:
                return 'Municipal Bonds';
            case ProductSubType.CorporateBonds:
                return 'Corporate Bonds';
            default:
                return '';
        }
    }

    static getProductGroupName(group: number): string {
        switch (group) {
            case ProductGroup.NotAvailable:
                return 'N/A';
            case ProductGroup.MiscellaneousCapitalProtectedCertificates:
                return 'Miscellaneous Capital Protected Certificates';
            case ProductGroup.CapitalProtectionCertificatewithParticipation:
                return 'Capital Protection Certificate With Participation';
            case ProductGroup.CapitalProtectionCertificatewithCoupon:
                return 'Capital Protection Certificate With Coupon';
            case ProductGroup.CapitalProtectionCertificatewithBarrier:
                return 'Capital Protection Certificate With Barrier';
            case ProductGroup.ReferenceEntityCertificatewithConditionalCapitalProtection:
                return 'Reference Entity Certificate With Conditional Capital Protection';
            case ProductGroup.Warrant:
                return 'Warrant';
            case ProductGroup.MiniFuture:
                return 'Mini Future';
            case ProductGroup.TrackerCertificate:
                return 'Tracker Certificate';
            case ProductGroup.OutperformanceCertificates:
                return 'Out Performance Certificates';
            case ProductGroup.MiscellaneousParticipationCertificate:
                return 'Miscellaneous Participation Certificate';
            case ProductGroup.BonusOutperformanceCertificate:
                return 'Bonus Out Performance Certificate';
            case ProductGroup.BonusCertificate:
                return 'Bonus Certificate';
            case ProductGroup.ReverseConvertible:
                return 'Reverse Convertible';
            case ProductGroup.MiscellaneousYieldEnhancementCertificates:
                return 'Miscellaneous Yield Enhancement Certificates';
            case ProductGroup.ExpressCertificates:
                return 'Express Certificates';
            case ProductGroup.DiscountCertificate:
                return 'Discount Certificate';
            case ProductGroup.ConditionalCouponReverseConvertible:
                return 'Conditional Coupon Reverse Convertible';
            case ProductGroup.ConditionalCouponBarrierReverseConvertible:
                return 'Conditional Coupon Barrier Reverse Convertible';
            case ProductGroup.BarrierReverseConvertible:
                return 'Barrier Reverse Convertible';
            case ProductGroup.BarrierDiscountCertificate:
                return 'Barrier Discount Certificate';
            default:
                return '';
        }
    }

    static getProductSettlementTypeName(type: number): string {
        switch (type) {
            case SettlementType.NotAvailable:
                return 'N/A';
            case SettlementType.CashSettlement:
                return 'Cash Settlement';
            case SettlementType.CashSettlementOrDelivery:
                return 'Cash Settlement or Delivery';
            default:
                return '';
        }
    }

    static getProductBarrierTypeName(type: number): string {
        switch (type) {
            case BarrierType.NotAvailable:
                return 'N/A';
            case BarrierType.BarrierObservationAtMaturityOnly:
                return 'Barrier Observation at Maturity Only';
            case BarrierType.ContinuousBarrierObservation:
                return 'Continuous Barrier Observation';
            case BarrierType.ContinuousBarrierObservationOnTheClose:
                return 'Continuous Barrier Observation on the Close';
            default:
                return '';
        }
    }

    static getProductWarrantTypeName(type: number): string {
        switch (type) {
            case WarrantType.NotAvailable:
                return 'N/A';
            case WarrantType.Call:
                return 'Call';
            case WarrantType.Put:
                return 'Put';
            default:
                return '';
        }
    }

    static getMessagingStatusName(type: string): string {
        switch (type) {
            case MessagingStatusesEnum.New:
                return 'New';
            case MessagingStatusesEnum.PendingApproval:
                return 'Pending Approval';
            case MessagingStatusesEnum.Rejected:
                return 'Rejected';
            case MessagingStatusesEnum.Approved:
                return 'Approved';
            case MessagingStatusesEnum.Failed:
                return 'Failed';
            case MessagingStatusesEnum.Sent:
                return 'Sent';
            case MessagingStatusesEnum.Received:
                return 'Received';
            case MessagingStatusesEnum.Read:
                return 'Read';
        }
    }

    static getMessagingDisrtibutionChannelName(type: string): string {
        switch (type) {
            case MessagingDistributionChannelsEnum.Email:
                return 'E-Mail';
            case MessagingDistributionChannelsEnum.Push:
                return 'Push';
            case MessagingDistributionChannelsEnum.Pull:
                return 'Pull';
        }
    }

    static getProductDurationInMonthsText(durationInMonths: number): string {
        if (durationInMonths % 12 === 0) {
            const isSingleYear = durationInMonths === 12;

            return durationInMonths + (isSingleYear ? ' year' : ' years');
        }

        const isSingleMonth = durationInMonths === 1;

        return durationInMonths + (isSingleMonth ? ' month' : ' months');
    }


    static getTradingPlanStatusName(status: number): string {
        switch (status) {
            case TradingPlanStatusEnum.All:
                return 'All';
            case TradingPlanStatusEnum.InActive:
                return 'InActive';
            case TradingPlanStatusEnum.Purchasable:
                return 'Purchasable';
            case TradingPlanStatusEnum.Active:
                return 'Active';
            case TradingPlanStatusEnum.Expired:
                return 'Expired';
            case TradingPlanStatusEnum.Set:
                return 'Set';
            case TradingPlanStatusEnum.OnHold:
                return 'On Hold';
            case TradingPlanStatusEnum.ActiveAndPurchasable:
                return 'Active And Purchasable';

        }
    }

    static getAccountPlanStatusName(status: number): string {
        switch (status) {
            case AccountPlanStatusEnum.InProgress:
                return 'In Progress';
            case AccountPlanStatusEnum.Successful:
                return 'Successful';
            case AccountPlanStatusEnum.Failed:
                return 'Failed';
            case AccountPlanStatusEnum.Rejected:
                return 'Rejected';


        }
    }

    static getOrderRoutesBrokerStatusName(status: number): string {
        switch (status) {
            case ExecutionBrokerStatusEnum.Unspecified:
                return 'Unspecified';
            case ExecutionBrokerStatusEnum.InActive:
                return 'InActive';
            case ExecutionBrokerStatusEnum.Active:
                return 'Active';
        }
    }

    static getTradingPlanTypeName(status: number): string {
        switch (status) {
            case TradingPlanTypeEnum.All:
                return 'All';
            case TradingPlanTypeEnum.Demo:
                return 'Demo';
            case TradingPlanTypeEnum.Tryout:
                return 'Tryout';
            case TradingPlanTypeEnum.Tournament:
                return 'Tournament';
            case TradingPlanTypeEnum.PrimeTrading:
                return 'Prime Trading';
            case TradingPlanTypeEnum.FundedAccount:
                return 'Funded Account';

        }
    }

    static getTradingPlanSubTypeName(status: number): string {
        switch (status) {
            case TradingPlanSubTypeEnum.DayTrading:
                return 'Day Trading';
            case TradingPlanSubTypeEnum.SwingTrading:
                return 'Swing Trading';
        }
    }

    static getTradingPlanSuccessfulCompletionName(status: number): string {
        switch (status) {
            case TradingPlanSuccessfulCompletionEnum.ActivateNextPlan:
                return 'Activate Next Plan';
            case TradingPlanSuccessfulCompletionEnum.SendEnrollEmail:
                return 'Send Enroll Email';
        }
    }


    static getTradingPlanPrizeTypeName(status: number): string {
        switch (status) {
            case TradingPlanPrizeTypeEnum.Fixed:
                return 'Fixed';
            case TradingPlanPrizeTypeEnum.Dynamic:
                return 'Dynamic';
        }
    }

    static getBrokerSearchExtendedInputTypeName(status: number): string {
        switch (status) {
            case BrokerSearchExtendedType.Route:
                return 'Route';
            case BrokerSearchExtendedType.RouteSet:
                return 'RouteSet';
        }
    }

    static getCouponStatusName(status: number): string {
        switch (status) {
            case CouponStatusEnum.Inactive:
                return 'Inactive';
            case CouponStatusEnum.Active:
                return 'Active';
            case CouponStatusEnum.Expired:
                return 'Expired';
        }
    }

    static getCouponDiscountTypeName(type: number): string {
        switch (type) {
            case CouponDiscountTypeEnum.Percentage:
                return 'Percentage';
            case CouponDiscountTypeEnum.FixedAmount:
                return 'Fixed Amount';
            case CouponDiscountTypeEnum.OverridePrice:
                return 'Override Price';
        }
    }

    static getCouponUserEligibilityTypeName(type: number): string {
        switch (type) {
            case CouponUserEligibilityTypeEnum.AllPurchases:
                return 'All Purchases';
            case CouponUserEligibilityTypeEnum.FirstPurchase:
                return 'First Purchase';
            case CouponUserEligibilityTypeEnum.ReturningPurchase:
                return 'Returning Purchase';
            case CouponUserEligibilityTypeEnum.ChallengePassed:
                return 'Challenge Passed';
        }
    }

    static getCouponPaymentMethodName(method: number): string {
        switch (method) {
            case CouponPaymentMethodEnum.All:
                return 'All';
            case CouponPaymentMethodEnum.Stripe:
                return 'Stripe';
            case CouponPaymentMethodEnum.Crypto:
                return 'Crypto';
        }
    }

    static getCouponApplicableToTypeName(type: number): string {
        switch (type) {
            case CouponApplicableToTypeEnum.All:
                return 'All';
            case CouponApplicableToTypeEnum.PlanPurchase:
                return 'Plan Purchase';
            case CouponApplicableToTypeEnum.RewindDailyLoss:
                return 'Rewind Daily Loss';
            case CouponApplicableToTypeEnum.AutoPassDeactivation:
                return 'Auto Pass Deactivation';
        }
    }

    static getCouponStatusTriggerName(trigger: number): string {
        switch (trigger) {
            case CouponStatusTriggerEnum.Activate:
                return 'Activate';
            case CouponStatusTriggerEnum.Deactivate:
                return 'Deactivate';
            case CouponStatusTriggerEnum.Reactivate:
                return 'Reactivate';
            case CouponStatusTriggerEnum.Expire:
                return 'Expire';
        }
    }

    static getCouponPlanScopeTypeName(type: number): string {
        switch (type) {
            case CouponPlanScopeTypeEnum.SpecificPlans:
                return 'Specific Plans';
            case CouponPlanScopeTypeEnum.AllPlansOfType:
                return 'All Plans Of Type';
        }
    }

    static getCloseoutPlanTypeName(type: number): string {
        switch (type) {
            case CloseoutPlanTypeEnum.UnrealizedLossPctOfCash:
                return 'Unrealized loss % of cash';
        }
    }

    static getCloseoutPlanStatusName(status: number): string {
        switch (status) {
            case CloseoutPlanStatusEnum.New:
                return 'New';
            case CloseoutPlanStatusEnum.Active:
                return 'Active';
            case CloseoutPlanStatusEnum.Inactive:
                return 'Inactive';
        }
    }

    static getCloseoutDeEscalationName(deEscalation: number): string {
        switch (deEscalation) {
            case CloseoutDeEscalationEnum.KeepMostSevereActionInPlace:
                return 'Keep most severe action in place';
        }
    }

    /** Per-account outcome of an attach/detach batch — the partial-success summary rows (spec §3.1). */
    static getCloseoutPlanAccountOperationOutcomeName(outcome: number): string {
        switch (outcome) {
            case CloseoutPlanAccountOperationOutcomeEnum.Attached:
                return 'Attached';
            case CloseoutPlanAccountOperationOutcomeEnum.Overwritten:
                return 'Overwritten';
            case CloseoutPlanAccountOperationOutcomeEnum.Detached:
                return 'Detached';
            case CloseoutPlanAccountOperationOutcomeEnum.SkippedAlreadyAttached:
                return 'Already attached';
            case CloseoutPlanAccountOperationOutcomeEnum.SkippedConflictRequiresConfirmation:
                return 'Overwrite not confirmed';
            case CloseoutPlanAccountOperationOutcomeEnum.SkippedNotAttachedToPlan:
                return 'Not attached to this plan';
            case CloseoutPlanAccountOperationOutcomeEnum.NotFound:
                return 'Not found';
        }
    }

    static getAccountCreationChannelName(channel: AccountCreationChannelEnum): string {
        switch (channel) {
            case AccountCreationChannelEnum.Standard:
                return 'Standard';
            case AccountCreationChannelEnum.OperatorBatch:
                return 'Operator batch';
        }
    }

    /** Per-account activation outcome of a batch trading-account creation; every listed account was created. */
    static getAccountCreationBatchOutcomeName(outcome: AccountCreationBatchOutcomeEnum): string {
        switch (outcome) {
            case AccountCreationBatchOutcomeEnum.CreatedActivated:
                return 'Created - activation initiated';
            case AccountCreationBatchOutcomeEnum.CreatedActivationNotInitiated:
                return 'Created - activation not initiated, needs manual follow-up';
            case AccountCreationBatchOutcomeEnum.Failed:
                return 'Created - activation failed';
        }
    }

    static getPortalName(portalId: number): string {
        switch (portalId) {
            case PortalsEnum.Crm:
                return 'CRM';
            case PortalsEnum.CrmFLB:
                return 'CRM FLB';
            case PortalsEnum.AlaricPro:
                return 'Alaric Pro';
            case PortalsEnum.AlaricFundPortal:
                return 'Alaric Fund Portal';
            case PortalsEnum.TenN:
                return '10N';
            case PortalsEnum.PrototypeFundPortal:
                return 'Prototype Fund Portal';
            case PortalsEnum.DemoAlaricPro:
                return 'Demo Alaric Pro';
            case PortalsEnum.HammerWeb:
                return 'Hammer Web';
            case PortalsEnum.AcePortal:
                return 'Ace Portal';
        }
    }
}
